function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.94 12.426h5.958l-5.957-5.957v5.957zm2.23 7.582v-2.06H17.03v-3.14H14.97v3.14H11.83v2.06h3.139v3.14h2.062v-3.14h3.14-.001zm-1.923-14.73l6.689 6.443V24.61c0 .57-.227 1.065-.68 1.485-.453.418-.975.629-1.567.629H9.31c-.592 0-1.114-.21-1.567-.63-.453-.42-.68-.914-.68-1.484L7.117 7.39c0-.57.217-1.065.653-1.485a2.15 2.15 0 011.541-.629h8.936z",
  fill: "#4A4A4A",
  fillRule: "nonzero"
})));